var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LockSimpleOpen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 3.75H4.5V2.625C4.5 2.22718 4.65804 1.84564 4.93934 1.56434C5.22064 1.28304 5.60218 1.125 6 1.125C6.72047 1.125 7.36875 1.64062 7.5075 2.32453C7.5281 2.42117 7.58601 2.50578 7.66864 2.55996C7.75128 2.61414 7.85195 2.63351 7.9488 2.61387C8.04564 2.59423 8.13081 2.53716 8.18581 2.45507C8.2408 2.37298 8.26118 2.2725 8.2425 2.17547C8.03062 1.13203 7.0875 0.375 6 0.375C5.40345 0.37562 4.83152 0.612873 4.4097 1.0347C3.98787 1.45652 3.75062 2.02845 3.75 2.625V3.75H2.25C2.05109 3.75 1.86032 3.82902 1.71967 3.96967C1.57902 4.11032 1.5 4.30109 1.5 4.5V9.75C1.5 9.94891 1.57902 10.1397 1.71967 10.2803C1.86032 10.421 2.05109 10.5 2.25 10.5H9.75C9.94891 10.5 10.1397 10.421 10.2803 10.2803C10.421 10.1397 10.5 9.94891 10.5 9.75V4.5C10.5 4.30109 10.421 4.11032 10.2803 3.96967C10.1397 3.82902 9.94891 3.75 9.75 3.75ZM9.75 9.75H2.25V4.5H9.75V9.75Z",
    fill: "#252526"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen1);
export default __webpack_public_path__ + "static/media/lock-open-1.99eeb1a0b3267c29cf4c2b2361ed033c.svg";
export { ForwardRef as ReactComponent };